import type { FC } from "react";
import React, { memo } from "react";
import styles from "./Services.module.scss";

/**
 * Only handles 2 levels deep!
 */
const InsuranceDescriptionList: FC<{ list: string | undefined }> = ({ list }) => {
    if (typeof list !== "string" || list.length === 0) {
        return null;
    }

    const parsedList = JSON.parse(list) as (string | string[])[];
    if (parsedList.length === 0) {
        return null;
    }

    const children: JSX.Element[] = [];
    for (let index = 0, listLength = parsedList.length; index < listLength; index += 1) {
        const currentItem = parsedList[index];
        if (typeof currentItem === "string") {
            // If next item is an array, then we need to render that item as a sublist in the current <li>
            const nextItem = parsedList[index + 1];
            if (Array.isArray(nextItem)) {
                index += 1; // Will skip the next item in the array because we already handle it here
                children.push(
                    <li key={currentItem}>
                        {currentItem}
                        <ul>
                            {nextItem.map((deepItem) => (
                                <li key={deepItem}>{deepItem}</li>
                            ))}
                        </ul>
                    </li>,
                );
            } else {
                children.push(<li key={currentItem}>{currentItem}</li>);
            }
        }
    }

    return <ul className={styles.list}>{children}</ul>;
};

export default memo(InsuranceDescriptionList);
